<script setup>
import {defineProps} from "vue";
import WebBasedPlayer from "@/components/players/WebBasedPlayer";
import PdfPlayer from "@/components/players/PdfPlayer";
import FileDownloader from "@/components/players/FileDownloader";
import VideoPlayer from "@/components/players/VideoPlayer";
import AudioPlayer from "@/components/players/AudioPlayer";

const props = defineProps({
    content: Object
});

</script>

<template>
    <WebBasedPlayer v-if="props.content.source === 'WEB'" :content="props.content"/>
    <PdfPlayer v-else-if="props.content.content_type_key === 'PdfFile'" :content="props.content"/>
    <FileDownloader v-else-if="props.content.source === 'FILE' && props.content.vertical === 'DOCUMENT'" :content="props.content"/>
    <VideoPlayer v-else-if="props.content.source === 'FILE' && props.content.vertical === 'VIDEO'" :content="props.content"/>
    <AudioPlayer v-else-if="props.content.source === 'FILE' && props.content.vertical === 'AUDIO'" :content="props.content"/>
</template>